<template>
  <div class="search-wrapper">
    <!-- <label>Search title:</label> -->
    <input type="text" :value="search" @input="inputHandler" :placeholder="$tc('user.filter.name')"/>
  </div>
</template>

<script>

import debounce from 'lodash.debounce'

export default {
  data: () => ({
    search: ''
  }),
  methods: {
    inputHandler: debounce(function (query) {
      this.search = query.target.value
      this.$emit('query-updated', this.search)
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// UserSearchInput.vue?140ecbf2